export default "__VITE_ASSET__Jkv00f0E__"